import type {PeriodPickerCommitted} from '../../../components/period-picker/use-period-picker';

const PERIOD_KEYS = ['period', 'month', 'from', 'to', 'preset'] as const;

export function readPeriod(params: URLSearchParams): PeriodPickerCommitted | null {
	const period = params.get('period');
	if (period === 'week') {
		return {toggle: 'week', month: '', customFrom: '', customTo: '', presetId: null};
	}
	if (period === 'month' && /^\d{4}-\d{2}$/.test(params.get('month') ?? '')) {
		return {toggle: 'month', month: params.get('month') ?? '', customFrom: '', customTo: '', presetId: null};
	}
	if (period === 'custom' && params.get('from') && params.get('to')) {
		return {
			toggle: 'custom',
			month: '',
			customFrom: params.get('from') ?? '',
			customTo: params.get('to') ?? '',
			presetId: null,
		};
	}
	if (period === 'preset' && params.get('preset')) {
		return {toggle: 'presets', month: '', customFrom: '', customTo: '', presetId: params.get('preset')};
	}
	return null;
}

export function samePeriod(left: PeriodPickerCommitted, right: PeriodPickerCommitted): boolean {
	if (left.toggle !== right.toggle) return false;
	if (left.toggle === 'month') return left.month === right.month;
	if (left.toggle === 'custom') return left.customFrom === right.customFrom && left.customTo === right.customTo;
	if (left.toggle === 'presets') return left.presetId === right.presetId;
	return true;
}

export function writePeriod(params: URLSearchParams, committed: PeriodPickerCommitted): URLSearchParams {
	const next = new URLSearchParams(params);
	for (const key of PERIOD_KEYS) next.delete(key);
	if (committed.toggle === 'week') next.set('period', 'week');
	if (committed.toggle === 'month' && committed.month) {
		next.set('period', 'month');
		next.set('month', committed.month);
	}
	if (committed.toggle === 'custom') {
		next.set('period', 'custom');
		if (committed.customFrom) next.set('from', committed.customFrom);
		if (committed.customTo) next.set('to', committed.customTo);
	}
	if (committed.toggle === 'presets' && committed.presetId) {
		next.set('period', 'preset');
		next.set('preset', committed.presetId);
	}
	return next;
}

export function readCompetitorIds(params: URLSearchParams): string[] {
	return (params.get('ids') ?? '')
		.split(',')
		.map((item) => item.trim())
		.filter(Boolean)
		.slice(0, 5);
}

export function writeCompetitorIds(params: URLSearchParams, ids: string[]): URLSearchParams {
	const next = new URLSearchParams(params);
	if (ids.length === 0) next.delete('ids');
	else next.set('ids', ids.slice(0, 5).join(','));
	return next;
}
